<template>
  <div class="ma-3">
    <div class="title mb-3">
      BEE SECURE Prices List
      <v-icon>mdi-chevron-right</v-icon>
      {{ isNew ? 'New period' : formatDate(fees.effective_date) }}
    </div>

    <v-form
      ref="form"
      v-model="formValid"
      layout="column"
      layout-align="center center"
      @submit.prevent="save"
    >
      <div>
        <div class="title font-weight-light mb-3">
          Prices list period information
        </div>
        <v-text-field
          v-model="effective_date_text"
          label="Start date"
          outline
          hide-details
          class="mb-4"
          @blur="fees.effective_date = parseDate(effective_date_text)"
        >
          <div slot="prepend-inner">
            <v-menu
              ref="searchStart"
              :close-on-content-click="false"
              :return-value.sync="fees.effective_date"
              transition="scale-transition"
              offset-y
              full-width
              lazy
            >
              <v-icon slot="activator">
                event
              </v-icon>
              <v-date-picker
                v-model="fees.effective_date"
                first-day-of-week="1"
                @input="$refs.searchStart.save(fees.effective_date); effective_date_text = americanizeDate(fees.effective_date);"
              />
            </v-menu>
          </div>
        </v-text-field>
        <v-text-field
          v-model="fees.events_amount"
          outline
          label="Price of 1h for events"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
        <v-text-field
          v-model="fees.adultstraining_amount"
          outline
          label="Price of 1h for adults trainings"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
        <v-text-field
          v-model="fees.schooltraining_amount"
          outline
          label="Price of 1h for school trainings"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
        <v-text-field
          v-model="fees.teacherstraining_amount"
          outline
          label="Price of 1h for teachers trainings"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
        <v-text-field
          v-model="fees.youthtraining_amount"
          outline
          label="Price of 1h for youth trainings"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
        <v-text-field
          v-model="fees.internalmeeting_amount"
          outline
          label="Price of 1h for internal meetings"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
        <v-text-field
          v-model="fees.intro_amount"
          outline
          label="Price of 1h for introducton day"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
        <v-text-field
          v-model="fees.others_amount"
          outline
          label="Price of 1h for others sessions"
          class="field-width"
          :rules="[ v => !!v || parseFloat(v) > 0 || 'This field is required' ]"
        />
      </div>

      <v-btn
        depressed
        color="primary"
        @click="save"
      >
        Save
      </v-btn>
      <router-link
        :to="{name: 'admin-fees-bs-priceslists-index'}"
        class="grey--text"
      >
        Cancel
      </router-link>
    </v-form>
  </div>
</template>

<script>
import Params from "@/api/params";
import GlobalMixin from "@/mixins/global";
import DatesMixin from "@/mixins/date";
import moment from "moment";

export default {
  mixins: [GlobalMixin, DatesMixin],
  data() {
    return {
      fees: {
        effective_date: null,
        animator_amount: 0.00,
        instructor_amount: 0.00,
        expert_amount: 0.00
      },
      formValid: false,
      effective_date_text: ""
    };
  },
  computed: {
    isNew() {
      return this.$route.params.id === "new";
    }
  },
  mounted() {
    if (!this.isNew) {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      Params.get("bs-prices-lists", this.$route.params.id).then(res => {
        this.fees = res.data
        this.effective_date_text = this.americanizeDate(this.fees.effective_date)
        this.fees.events_amount = this.fees.events_amount.replace('.', ',')
        this.fees.adultstraining_amount = this.fees.adultstraining_amount.replace('.', ',')
        this.fees.schooltraining_amount = this.fees.schooltraining_amount.replace('.', ',')
        this.fees.teacherstraining_amount = this.fees.teacherstraining_amount.replace('.', ',')
        this.fees.youthtraining_amount = this.fees.youthtraining_amount.replace('.', ',')
        this.fees.internalmeeting_amount = this.fees.internalmeeting_amount.replace('.', ',')
        this.fees.intro_amount = this.fees.intro_amount.replace('.', ',')
        this.fees.others_amount = this.fees.others_amount.replace('.', ',')
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.fees.events_amount = this.fees.events_amount.replace(',', '.').replace(' ', '')
      this.fees.adultstraining_amount = this.fees.adultstraining_amount.replace(',', '.').replace(' ', '')
      this.fees.schooltraining_amount = this.fees.schooltraining_amount.replace(',', '.').replace(' ', '')
      this.fees.teacherstraining_amount = this.fees.teacherstraining_amount.replace(',', '.').replace(' ', '')
      this.fees.youthtraining_amount = this.fees.youthtraining_amount.replace(',', '.').replace(' ', '')
      this.fees.internalmeeting_amount = this.fees.internalmeeting_amount.replace(',', '.').replace(' ', '')
      this.fees.intro_amount = this.fees.intro_amount.replace(',', '.').replace(' ', '')
      this.fees.others_amount = this.fees.others_amount.replace(',', '.').replace(' ', '')
			if (this.isNew) {
        Params.create("bs-prices-lists", this.fees).then(() => {
          this.$router.push({ name: "admin-fees-bs-priceslists-index" });
          this.$snotify.success(
            `The period for BEE SECURE prices list "${this.formatDate(this.fees.effective_date)}" has been created`
          );
        });
      } else {
        Params.update("bs-prices-lists", this.fees.id, this.fees).then(() => {
          this.$router.push({ name: "admin-fees-bs-priceslists-index" });
          this.$snotify.success(
            `The period for BEE SECURE prices list "${this.formatDate(this.fees.effective_date)}" has been updated`
          );
        });
      }
    },
    americanizeDate(date) {
      if (!date) return null;

      if (date.indexOf(".") >= 0) {
        return date;
      }

      return moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
    },
    parseDate(date) {
      if (!date) return null;

      if (date.indexOf("-") >= 0) {
        return date;
      }

      return moment(date, "DD.MM.YYYY").format("YYYY-MM-DD");
    }
  }
};
</script>
